import {Link} from "react-router-dom";
import {PATHS} from "../../../../../../routers/utils/Paths.links";

const NoItems = ({purchasesServices, purchasesProducts}) => {
    if (purchasesServices.length || purchasesProducts.length) return null;

    return (
        <div className="bk-empty">
            <div className="bk-empty-icon" aria-hidden="true">
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 4h2l2.4 11.2a2 2 0 002 1.6h7.7a2 2 0 002-1.5L21 8H6.2" />
                    <circle cx="10" cy="20" r="1.3" />
                    <circle cx="17" cy="20" r="1.3" />
                </svg>
            </div>
            <h3>Кошик порожній</h3>
            <p>Куплені товари з'являться тут — звідси їх можна забрати в грі.</p>
            <Link className="bk-empty-btn" to={PATHS.SHOP}>До магазину</Link>
        </div>
    );
};

export default NoItems;
